import { MissionData } from '../blocks/mission'
import template from './templates/RJF03.rbxl'
import thumbnail1 from './thumbnails/RJF03/SpawnLocation.png'
import thumbnail2 from './thumbnails/RJF03/Oodama.png'
import thumbnail3 from './thumbnails/RJF03/Wall.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
    },
    {
      name: '②おおだま',
      thumbnail: thumbnail2,
    },
    {
      name: '③みどりのかべ',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
